export const ViewMode  = {
    NEW:"NEW",
    EDIT:"EDIT",
    VIEW:"VIEW",
}